import { logError } from '@tools/LogsHandler.tsx';
import { openNotificationWithIcon } from '@tools/utils/common.tsx';
import type { ErrorResponseState } from '@tools/types/common.types.ts';

import type { CleanCartResult } from '@eshop/types/cart.types.ts';

const FALLBACK_ERROR_MESSAGE = 'No pudimos vaciar tu carrito. Intentá nuevamente en unos segundos.';

const resolveErrorText = (error: unknown): string => {
    if (typeof error === 'string') {
        return error;
    }
    if (error && typeof error === 'object') {
        const payload = error as Partial<ErrorResponseState> & { detail?: unknown };

        if (typeof payload.detail === 'string' && payload.detail.trim().length > 0) {
            return payload.detail;
        }

        const responseData = payload.response?.data;
        if (typeof responseData === 'string' && responseData.trim().length > 0) {
            return responseData;
        }

        if (responseData && typeof responseData === 'object') {
            const detail = (responseData as { detail?: unknown }).detail;
            if (typeof detail === 'string' && detail.trim().length > 0) {
                return detail;
            }

            const errorMessage = (responseData as { error?: unknown }).error
                ?? (responseData as { message?: unknown }).message;
            if (typeof errorMessage === 'string' && errorMessage.trim().length > 0) {
                return errorMessage;
            }
        }

        if (typeof payload.message === 'string' && payload.message.trim().length > 0) {
            return payload.message;
        }
    }
    if (error instanceof Error && error.message.trim().length > 0) {
        return error.message;
    }
    return FALLBACK_ERROR_MESSAGE;
};

export const notifyCartClearedSuccess = (result: CleanCartResult) => {
    const description = result.status === 'empty'
        ? 'Tu carrito ya estaba vacío. Podés seguir explorando el catálogo.'
        : 'El carrito se vació correctamente y sincronizamos tu vista con el servidor.';
    openNotificationWithIcon('success', 'Carrito vacío', description);
};

export const notifyCartClearedError = (error: unknown) => {
    const description = resolveErrorText(error);
    logError('Error al vaciar el carrito', error);
    openNotificationWithIcon('error', 'No se pudo vaciar el carrito', description);
};

export const resolveCartClearErrorMessage = resolveErrorText;
